import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CatchWeightItem } from 'components/verify-item/verify-item-catch-weight'
import { TripContext } from 'contexts'
import { CatchWeightOptions } from 'enums'
import React, { FC, Fragment, useContext } from 'react'
import { CatchWeight, Order, OrderItem, ReconcileReason } from 'services/types'
import './catch-weight-card.scss'

type Props = {
    items?: CatchWeight[],
    onClickOperationMode: (options: CatchWeightOptions, id: number, editedWeight: number) => void,
    onAddCatchWeight: (orderId?: number) => void,
    onClickShowVerifiedButton: (orderId?: number) => void,
    isShowVerifiedItemsEnabled: boolean,
    stopId: number | undefined
    lineItemId: number,
    orderId?: number
}

export const CatchWeightCard: FC<Props> = ({ stopId, lineItemId, onClickOperationMode = () => { }, onAddCatchWeight = () => { }, onClickShowVerifiedButton = () => { }, isShowVerifiedItemsEnabled, orderId }) => {
    const tripContext = useContext(TripContext)
    const reconcileReasons: ReconcileReason[] = tripContext.reconcileReasons.toArray() ?? []

    let orderItems: OrderItem[] = []
    let catchWeightItems: CatchWeight[] = []
    const orders: Order[] = tripContext.orders.filter(o => o.stopId == stopId)

    orders.forEach(order => {
        orderItems = [...orderItems, ...tripContext.orderItems.filter(oi => oi.orderId == order.id && oi.lineItemId == lineItemId)]
    })

    orderItems.forEach(orderItem => {
        catchWeightItems = [...catchWeightItems, ...tripContext.catchWeights.filter(cw => cw.orderItemId == orderItem.id)]
    })

    if (orderId) {
        catchWeightItems = []
        catchWeightItems = [...catchWeightItems, ...tripContext.catchWeights.filter(cw => cw.orderItemId == orderId)]
    }    

    let items: CatchWeight[] = isShowVerifiedItemsEnabled ? catchWeightItems : catchWeightItems.filter(item => item.catchWeightOptions !== CatchWeightOptions.Verified)

    if (orderId) {
        items = isShowVerifiedItemsEnabled ? catchWeightItems.filter(item => item.orderItemId === orderId) : catchWeightItems.filter(item => item.catchWeightOptions !== CatchWeightOptions.Verified && item.orderItemId === orderId)
    }   

    items = items.sort((a, b) => a.shippedWeight == null ? 1 : ((a.shippedWeight > b.shippedWeight) ? 1 : -1))

    return (
        <Fragment>
            <div className={'catch-weight-heading'}>
                <div className={'catch-weight-icon'}>
                    <FontAwesomeIcon icon={faPlus as IconProp} size={'2x'} color={'green'} onClick={() => onAddCatchWeight(orderId ? orderId : orderItems?.[0]?.id)} />
                </div>
                <div className={'catch-weight-title'}>Catch Weight</div>
                <div className={'catch-weight-button'} onClick={() => onClickShowVerifiedButton(orderId)}>{isShowVerifiedItemsEnabled ? 'Hide Verified Items' : 'Show Verified Items'}</div>
            </div>
            <Fragment>
                {items && items.map(i => <CatchWeightItem key={i.id} catchWeight={i} reconcileReasons={reconcileReasons} onClickOperationMode={onClickOperationMode} />)}
            </Fragment>
        </Fragment>
    )
}